<template>
  <div class="container-wrapper">
    <div class="inner-container">
      <v-row class="main-row">
        <v-col class="aside">
          <v-row class="aside__heading">
            <h3 class="aside__heading__ci">
              <!-- 헤더로고 -->
              <img class="aside__heading__ci__image--auto" src="../../assets/login/autocryptKor.png" />
            </h3>
          </v-row>
          <v-row class="aside__head-content">
            <p class="aside__head-content__intro">
              모두를 위한 <strong class="bold">바우처 택시</strong>
            </p>
            <p class="aside__head-content--detail">
              <strong class="bold">AutoCrypt EQ</strong>와 함께 세상을 바꾸는 특별한 이동을 경험하세요.
            </p>
            <div class="d-flex">
              <div class="aside__head-content--mobile">
                <a href="https://play.google.com/store/apps/details?id=com.autocrypt.eu.driver" target="_blank">
                  <img class="aside__head-content--mobile__image" src="../../assets/login/img_googleplay.png" />
                </a>
              </div>
              <div class="aside__head-content--mobile" style="margin-left: 16px">
                <a href="https://apps.apple.com/us/app/id1527684763" target="_blank">
                  <img class="aside__head-content--mobile__image" src="../../assets/login/namu_iphone.png" />
                </a>
              </div>
            </div>
          </v-row>
        </v-col>
        <v-col class="main">
          <div class="main__title-box">
            <img class="main__title-box__image" src="../../assets/login/EQLogin.png">
          </div>
          <v-form
              class="main__form"
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <div>
              <v-text-field
                  required
                  :rules="[v => !!v || '아이디를 입력해주세요']"
                  outlined
                  class="main__form__input"
                  v-model="loginForm.loginId"
                  @keypress.enter="submit"
                  placeholder="아이디"
                  autofocus
              />
            </div>
            <div>
              <v-text-field
                  required
                  :rules="[v => !!v || '비밀번호를 입력해주세요.']"
                  outlined
                  class="main__form__input"
                  type="password"
                  v-model="loginForm.password"
                  @keypress.enter="submit"
                  placeholder="비밀번호"
              />
            </div>
            <button
                class="main__form__submit"
                primary
                type="button"
                @click="submit"
            >
              로그인
            </button>
          </v-form>
        </v-col>
      </v-row>
    </div>
    <footer class="footer" height="90">
      <p class="footer__content">All Rights Reserved with <strong class="bold">AUTOCRYPT EQ</strong></p>
    </footer>
  </div>
</template>
<script>

const {setTokenConfig} = require("@/api/settiing");

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        loginId: '',
        password: ''
      },
      centerInfo: [],
      valid: false,

      message: '',
      snackbar: false,

    }
  },
  methods: {
    async getCenter() {
      try {
        const res = await this.$api.getCenter(this.$store.state.service);
        for (const i in res.data) {
          const item = res.data[i];
          if(item.status === 'Enable'){
            this.centerInfo.push({
              text: item.centerName,
              value: item.id,
              garagePoint: item.garagePoint,
              centerPoint: item.centerPoint,
              weekday : item.weekday,
              weekdayFirstDrive : item.weekdayFirstDrive,
              weekdayLastDrive : item.weekdayLastDrive,
              weekdayFirstResv : item.weekdayFirstResv,
              weekdayLastResv : item.weekdayLastResv,
              weekend : item.weekend,
              weekendFirstDrive : item.weekendFirstDrive,
              weekendLastDrive : item.weekendLastDrive,
              weekendFirstResv : item.weekendFirstResv,
              weekendLastResv : item.weekendLastResv,
              centerPay : item.centerPay,
              useList: item.useList,
            })
          }
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'getCenter'});
      }
    },
    async submit() {
      if (!(this.$refs.form.validate())) {
        this.$store.commit('snackbar', {msg: '비어있는 필드가 있습니다.'});
        return;
      }
      try {
        const formData = new FormData();
        formData.append('loginId', this.loginForm.loginId);
        formData.append('password', this.loginForm.password);
        formData.append('temp', false);

        const { data:adminInfo } = await this.$api.login(formData);
        await setTokenConfig(adminInfo.token, adminInfo.refreshToken);

        const { data:roleData } = await this.$api.getUserRouteList();// login한 admin의 접근 가능 메뉴 리스트
        const token = sessionStorage.getItem('token')
        const tokenDecodablePart=token.split('.')[1];
        const base64 = Buffer.from(tokenDecodablePart, 'base64').toString();
        const tokenInfo = JSON.parse(base64)


        const { centerId } = roleData;
        await this.getConfigVal();
        let targetCenter = this.centerInfo.filter(item => (item.value === tokenInfo.centerId));
        this.$store.commit('userInfo', {
          loginId: this.loginForm.loginId,
          centerId: targetCenter[0].value,
          centerName: targetCenter[0].text,
          garagePoint: targetCenter[0].garagePoint,
          centerPoint: targetCenter[0].centerPoint,
          role: adminInfo.role,
          categoryName: roleData.categoryName,
          subRouteName: roleData.subRouteName,
        });

        this.$store.commit('centerInfo', {
          centerId: targetCenter[0].value,
          centerName: targetCenter[0].text,
          garagePoint: targetCenter[0].garagePoint,
          centerPoint: targetCenter[0].centerPoint,
          weekday : targetCenter[0].weekday,
          weekdayFirstDrive : targetCenter[0].weekdayFirstDrive,
          weekdayLastDrive : targetCenter[0].weekdayLastDrive,
          weekdayFirstResv : targetCenter[0].weekdayFirstResv,
          weekdayLastResv : targetCenter[0].weekdayLastResv,
          weekend : targetCenter[0].weekend,
          weekendFirstDrive : targetCenter[0].weekendFirstDrive,
          weekendLastDrive : targetCenter[0].weekendLastDrive,
          weekendFirstResv : targetCenter[0].weekendFirstResv,
          weekendLastResv : targetCenter[0].weekendLastResv,
          centerPay : targetCenter[0].centerPay,
          useList : targetCenter[0].useList,
        });


        await this.$router.push('/dashboard');
      } catch (err) {
        this.loginForm.password = '';
        this.loginForm.loginId = '';
        this.$store.commit('snackbar', {err, where: 'submit', msg: '일치하는 회원정보가 없습니다.'});
      }
    },
    async getConfigVal() {
      try {
        const res = await this.$api.getConfigVal();

        const data = {...res.data};
        this.$store.commit('config', data);

      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'getConfigVal'});
      }
    },
  },
  mounted() {
    this.getCenter();
  },
}

</script>

<style lang="scss" scoped>
$main-width: 35vw;
$main-color:#8C78FF;


.container-wrapper {
  width: calc(100% + 40px);
  max-width: calc(100% + 40px);
  height: calc(100% + 20px);
  margin: -20px -20px 0 -20px;
  padding: 0;
}

.inner-container {
  height: calc(100% - 90px);
}

.main-row {
  height: 100%;
}

.aside {
  background-image: url("../../assets/login/namu_background.png");
  background-repeat: no-repeat;
  background-color: #fff;
  background-size: cover;
  background-position-y: bottom;
  background-position-x: right;
  width: calc(100% - #{$main-width});
  padding: 54px 30px 30px 84px;
  flex: none;

  &__heading {

    &__ci {
      display: flex;
      align-items: center;

      &__image {
        margin-right: 0.3vw;

        &--coop {
          max-width: 13vw;
        }

        &--x {
          max-width: 3vw;
        }

        &--auto {
          max-width: 11vw;
        }
      }
    }
  }

  &__head-content {
    display: flex;
    flex-direction: column;
    margin-top: 17vh;

    &__intro {
      font-size: 2.3vw;
      margin: 5px 0;
      padding: 0;
    }

    &--detail {
      font-size: 1.2vw;
      margin: 0 0 15px 0;
      padding: 0;
    }

    &--mobile {
      height: 63px;

      &__image {
        cursor: pointer;
        max-width: 19vh;
      }
    }
  }
}

.mobile-access-button {

}

.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: $main-color;

  &__title-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 31px;

    &__image {
      margin-bottom: 20px;
    }

    &__heading {
      font-size: 36px;
      min-font-size: 2.8vw;
    }
  }

  &__form-item {
    height: 85px;
    margin-bottom: 5px;
  }

  &__form {
    max-width: 50vw;
    width: 80%;

    &__input {

      ::v-deep {
        fieldset {
          border: 1px solid #C0C4CC;
          transition: border 0.3s;
          background-color: rgba(255, 255, 255, 0.2);
        }

        label {
          color: #fff !important;
        }

        input {
          color: #fff !important;
          font-size: 16px;
        }

        input::placeholder {
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }

    &__input:focus-within {
      ::v-deep {
        fieldset {
          border: 1px solid #fff;
        }
      }
    }

    &__submit {
      margin-top: 20px;
      width: 100%;
      height: 50px;
      color: #fff;
      background: #000;
      border: none;
      border-radius: 6px;
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.footer {
  background-color: #000;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 90px;
  height: 90px;

  &__content {
    font-size: 2vh;
  }
}

.bold {
  font-weight: bold;
}

@media screen and (max-width: 1200px) {
  .main {
    &__title-box {
      &__heading {
        font-size: 2.8vw;
      }
    }
  }
}

@media screen and (max-width: 912px) {
  .inner-container {
    height: calc(100% - 45px);
  }

  .aside {
    width: 0;
    height: 0;
    padding: 0;
    margin: 0;
    display: none;
  }

  .main {
    &__title-box {
      &__heading {
        font-size: 28px;
      }
    }

    &__form {
      min-width: 250px;
    }
  }

  .footer {
    max-height: 45px;

    &__content {
      font-size: 1.5vw;
    }
  }
}
</style>
